import script from "./AdvancesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdvancesPage.vue?vue&type=script&setup=true&lang=ts"

import "./AdvancesPage.vue?vue&type=style&index=0&id=53c63fcc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53c63fcc"]])

export default __exports__